import { render } from "./LoyaltyBenefitIcons.vue?vue&type=template&id=23225de0&scoped=true"
import script from "./LoyaltyBenefitIcons.vue?vue&type=script&lang=js"
export * from "./LoyaltyBenefitIcons.vue?vue&type=script&lang=js"

import "./LoyaltyBenefitIcons.vue?vue&type=style&index=0&id=23225de0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23225de0"]])

export default __exports__